import type { AuthenticatedIdentity } from '@isg/shared-types';
import { authenticatedIdentitySchema } from '@isg/validation';

/** Korumalı uç: token'la 200 + kimlik bekler; yanıt ağ kenarında doğrulanır. */
export async function fetchMe(
  accessToken: string,
  signal?: AbortSignal,
): Promise<AuthenticatedIdentity> {
  const response = await fetch('/api/me', {
    headers: { Authorization: `Bearer ${accessToken}` },
    signal,
  });
  if (!response.ok) {
    throw new Error(`API ${response.status} döndü`);
  }
  return authenticatedIdentitySchema.parse(await response.json());
}

/**
 * Negatif kanıt (§9): AYNI uca token'SIZ istek. Beklenen 401 — guard'ın
 * kapıyı gerçekten kapattığının ekranda görünen kanıtı.
 */
export async function probeMeWithoutToken(signal?: AbortSignal): Promise<number> {
  const response = await fetch('/api/me', { signal });
  return response.status;
}
